import axios from "axios";
import { API_BASE_URL } from "../../utils/config";

const createCompanyGain = async (user, companyGainData, branchId) => {
  try {
    if (!user) {
      return null;
    }

    const idTokenResult = await user.getIdTokenResult();
    if (
      (idTokenResult.claims.superAdmin ||
        idTokenResult.claims.admin ||
        idTokenResult.claims.subAdmin) === true
    ) {
      const idToken = await user.getIdToken();
      const res = await axios.post(
        `${API_BASE_URL}price/gain/${branchId}`,
        companyGainData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${idToken}`,
          },
        }
      );
      return res;
    } else {
      throw new Error(`You are not authorized to create company gain.`);
    }
  } catch (error) {
    if (error.isAxiosError) {
      throw new Error(error.message);
    } else {
      throw error;
    }
  }
};

export default createCompanyGain;
